import { REQUEST } from 'Stores'
import { GET_CONTACT, UPDATE__STATUS_CONTACT } from './constants'

export function getContactList(payload) {
  return {
    type: REQUEST(GET_CONTACT),
    payload
  }
}

export function updateStatusContact(payload) {
  return {
    type: REQUEST(UPDATE__STATUS_CONTACT),
    payload
  }
}
